import { type GameData } from '../../model'

export function isOldGameVersion(game: GameData): boolean {
  return game.version === 1 || !game.version
}

export function isNewGameVersion(game: GameData): boolean {
  return !isOldGameVersion(game)
}
